var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact_container"},[_c('div',{staticClass:"section"},[_c('img',{attrs:{"src":_vm.icon}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"note"},[_c('span',[_vm._v(_vm._s(_vm.note))]),_c('span',{staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.noteZh))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }